var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 42.8936V30.8936M32 36.8936H44M44 20.8936H4M44 24.8936V17.2936C44 15.0533 44 13.9332 43.564 13.0776C43.1805 12.3249 42.5686 11.713 41.816 11.3295C40.9603 10.8936 39.8402 10.8936 37.6 10.8936H10.4C8.15979 10.8936 7.03969 10.8936 6.18404 11.3295C5.43139 11.713 4.81947 12.3249 4.43597 13.0776C4 13.9332 4 15.0533 4 17.2936V32.4936C4 34.7338 4 35.8539 4.43597 36.7095C4.81947 37.4622 5.43139 38.0741 6.18404 38.4576C7.03969 38.8936 8.15979 38.8936 10.4 38.8936H24",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.638b788098f01944cf7207f6419adad1.svg";
export { ForwardRef as ReactComponent };